import React, { useEffect, useState } from "react";

const GRID_SIZE = 5;

// Rotate tile 90° clockwise
const rotate = angle => (angle + 90) % 360;

// Random array element
const choice = arr => arr[Math.floor(Math.random() * arr.length)];

export default function PlumberGame() {
    const [grid, setGrid] = useState([]);

    useEffect(() => {
        fetch("/all_grids.csv")
            .then(res => res.text())
            .then(text => {
                const grids = parseCSV(text);

                if (grids.length === 0) {
                    console.error("No valid grids parsed!");
                    return;
                }

                const selected = choice(grids);
                setGrid(convertToGameGrid(selected));
            })
            .catch(err => console.error("Failed to load grids:", err));
    }, []);

    // -------------------------------
    // PARSER FOR YOUR EXACT CSV FORMAT
    // -------------------------------
    function parseCSV(text) {
        const lines = text.split(/\r?\n/);

        let grids = [];
        let current = [];

        for (let line of lines) {
            line = line.trim();

            // Start of a new grid
            if (/^Grid\s+\d+/.test(line)) {
                if (current.length === GRID_SIZE) {
                    grids.push(current);
                }
                current = [];
                continue;
            }

            // Skip blank lines
            if (line === "") continue;

            // Parse row
            const row = line
                .split(",")
                .map(x => x.trim())
                .slice(0, GRID_SIZE); // enforce 5 columns

            if (row.length === GRID_SIZE) {
                current.push(row);
            }
        }

        // Push last grid
        if (current.length === GRID_SIZE) {
            grids.push(current);
        }

        return grids;
    }

    // -----------------------------
    // TILE LOGIC → elbow/straight
    // -----------------------------
    function convertToGameGrid(base) {
        const result = [];

        for (let r = 0; r < GRID_SIZE; r++) {
            const row = [];

            for (let c = 0; c < GRID_SIZE; c++) {
                const cell = base[r][c];

                if (["N", "E", "S", "W"].includes(cell)) {
                    const neighbors = {
                        N: r > 0 ? base[r - 1][c] : null,
                        S: r < GRID_SIZE - 1 ? base[r + 1][c] : null,
                        W: c > 0 ? base[r][c - 1] : null,
                        E: c < GRID_SIZE - 1 ? base[r][c + 1] : null,
                    };

                    let dirs = Object.entries(neighbors)
                        .filter(([_, v]) => v === cell)
                        .map(([dir]) => dir);

                    let angle = 0;
                    let image = "random.png";

                    if (dirs.length === 2) {
                        if (dirs.includes("N") && dirs.includes("S")) {
                            image = "straight.png";
                            angle = 0;
                        } else if (dirs.includes("E") && dirs.includes("W")) {
                            image = "straight.png";
                            angle = 90;
                        } else {
                            image = "elbow.png";

                            const key = dirs.sort().join("");

                            const elbowMap = {
                                "EN": 90,
                                "ES": 180,
                                "SW": 270,
                                "NW": 0
                            };

                            angle = elbowMap[key] ?? 0;
                        }
                    } else {
                        image = "random.png";
                        angle = choice([0, 90, 180, 270]);
                    }

                    row.push({ angle, image });
                } else {
                    row.push({
                        angle: choice([0, 90, 180, 270]),
                        image: "random.png"
                    });
                }
            }

            result.push(row);
        }

        return result;
    }

    // -----------------------------
    // Rotation handler
    // -----------------------------
    function handleClick(r, c) {
        const copy = grid.map(row => row.map(cell => ({ ...cell })));
        copy[r][c].angle = rotate(copy[r][c].angle);
        setGrid(copy);
    }

    if (grid.length === 0) return <div>Loading…</div>;

    return (
        <div style={{ textAlign: "center" }}>
            <h2>Pipe Game</h2>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${GRID_SIZE}, 64px)`,
                    gridTemplateRows: `repeat(${GRID_SIZE}, 64px)`,
                    gap: "4px",
                    margin: "0 auto"
                }}
            >
                {grid.map((row, r) =>
                    row.map((cell, c) => (
                        <div
                            key={`${r}-${c}`}
                            onClick={() => handleClick(r, c)}
                            style={{
                                width: 64,
                                height: 64,
                                backgroundImage: `url(/pipe_tiles/${cell.image})`,
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                transform: `rotate(${cell.angle}deg)`,
                                cursor: "pointer"
                            }}
                        ></div>
                    ))
                )}
            </div>
        </div>
    );
}
